import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// ────────────────────────────────
// 아이콘 컴포넌트 (equip / contact)
// ────────────────────────────────
const ArVrInfoIcon = ({ type }) => {
  return (
    <div className={`arvr_info_icon type_${type}`}>
      {type === 'equip' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3" y="5" width="18" height="12" rx="2" />
          <line x1="3" y1="13" x2="21" y2="13" />
          <rect x="9" y="18" width="6" height="2" />
        </svg>
      )}
      {type === 'contact' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 4h3l2 4-2 1c.8 2 2.2 3.4 4.2 4.2l1-2 4 2v3c0 1-1 2-2 2C10.5 18.8 5.2 13.5 4 6c0-1 1-2 2-2z" />
        </svg>
      )}
    </div>
  );
};

// ────────────────────────────────
// AR/VR 카드 (슬라이드 포함)
// ────────────────────────────────
const ArVrRoomCard = ({ building, roomName, roomDetail, images, infoList }) => {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const hasMulti = images.length > 1;

  const handlePrev = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleReserve = () => {
    navigate('/board/facility/write', { state: { step: 1 } });
  };

  return (
    <div className="arvr_room_block">
      {/* 좌측 이미지 + 슬라이드 */}
      <div className="arvr_img_group">
        <div className={`arvr_img ${images[current]}`}></div>

        {hasMulti && (
          <>
            <button type="button" className="meeting_slide_btn meeting_slide_prev" onClick={handlePrev}>
              ‹
            </button>
            <button type="button" className="meeting_slide_btn meeting_slide_next" onClick={handleNext}>
              ›
            </button>
          </>
        )}
      </div>

      {/* 우측 텍스트 */}
      <div className="arvr_text_area">
        <div className="arvr_top_row">
          <div className="arvr_title_group">
            <span className="arvr_building">{building}</span>
            <span className="arvr_roomname">{roomName}</span>
          </div>
          <div className="arvr_top_right">
            <span className="arvr_room_detail">{roomDetail}</span>
            <button type="button" className="arvr_apply_btn" onClick={handleReserve}>
              신청하기
            </button>
          </div>
        </div>

        <div className="arvr_info_panel">
          {infoList.map((item, idx) => (
            <div className="arvr_info_item" key={idx}>
              <ArVrInfoIcon type={item.type} />
              <div className="arvr_info_text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ArVr = () => {
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };
  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };
  const movePage = (path) => {
    navigate(path);
  };
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area arvr">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}보유시설{' > '}AR/VR
            </div>
            <div className="banner_main_text">AR/VR</div>
          </div>
        </div>

        {/* 상단 드롭다운 네비 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">보유시설</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>
            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">AR/VR</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  회의실
                </div>
                <div className="select_row" onClick={() => movePage('/computer')}>
                  전산실습실
                </div>
                <div className="select_row" onClick={() => movePage('/printing')}>
                  3D프린터
                </div>
                <div className="select_row" onClick={() => movePage('/arvr')}>
                  AR/VR
                </div>
                <div className="select_row" onClick={() => movePage('/cnc')}>
                  CNC/MCT
                </div>
                <div className="select_row" onClick={() => navigate('/board/facility/write', { state: { step: 1 } })}>
                  시설예약
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 영역 – MeetingRoom과 같은 컨테이너 사용 */}
        <div className="sub_main_area meetingroom">
          {/* 고정 사이드바 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>보유시설</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/meetingroom')}`} onClick={() => movePage('/meetingroom')}>
                <span>회의실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/computer')}`} onClick={() => movePage('/computer')}>
                <span>전산실습실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/printing')}`} onClick={() => movePage('/printing')}>
                <span>3D프린터</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/arvr')}`} onClick={() => movePage('/arvr')}>
                <span>AR / VR</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/cnc')}`} onClick={() => movePage('/cnc')}>
                <span>CNC / MCT</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/facility/write')}`}
                onClick={() => movePage('/board/facility/write')}
              >
                <span>시설예약</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* MeetingRoom과 동일 컨테이너 + 카드 */}
          <div className="meeting_section_back meetingroom">
            <div className="meeting_section_container">
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">보유시설 - AR/VR</div>
              </div>

              <ArVrRoomCard
                building="VR체험실습실"
                roomName="203호"
                roomDetail="203호 VR체험실습실"
                images={['vr-room-image1', 'vr-room-image2']}
                infoList={[
                  { type: 'equip', text: '주요 시설: VR장비 2대, 스크린' },
                  { type: 'contact', text: '사용문의: 041-354-8558' },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArVr;
